function guestGuard(store) {
  return (to, from, next) => {
    if (store.getters.authCheck) {
      next({name: APP_ROUTENAME_AUTH_HOME })
    } else {
      next()
    }
  }
}

export default guestGuard
